import { useEffect, useRef, useState } from "react";
// Style
import "./styles/EmojiPicker.scss";
import Emoji from "../Emoji/Emoji";
interface IProps {
    emo: string;
    fn: (el: string) => void;
}

const EmojiPicker = ({ emo = "smile", fn }: IProps) => {
    const [currentEmoji, setCurrentEmoji] = useState(emo);
    useEffect(() => setCurrentEmoji(emo), [emo]);
    const emojiListDiv = useRef<HTMLDivElement>(null);
    const emojiList = [
        "grin",
        "joy",
        "smiley",
        "smile",
        "sweat_smile",
        "laughing",
        "innocent",
        "smiling_imp",
        "wink",
        "blush",
        "yum",
        "relieved",
        "heart_eyes",
        "sunglasses",
        "smirk",
        "neutral_face",
        "expressionless",
        "unamused",
        "sweat",
        "pensive",
        "confused",
        "confounded",
        "kissing",
        "kissing_heart",
        "kissing_smiling_eyes",
        "kissing_closed_eyes",
        "stuck_out_tongue",
        "stuck_out_tongue_winking_eye",
        "stuck_out_tongue_closed_eyes",
        "disappointed",
        "worried",
        "angry",
        "rage",
        "cry",
        "persevere",
        "triumph",
        "disappointed_relieved",
        "frowning",
        "anguished",
        "fearful",
        "weary",
        "sleepy",
        "tired_face",
        "grimacing",
        "sob",
        "face_exhaling",
        "open_mouth",
        "hushed",
        "cold_sweat",
        "scream",
        "astonished",
        "flushed",
        "sleeping",
        "face_with_spiral_eyes",
        "dizzy_face",
        "face_in_clouds",
        "no_mouth",
        "mask",
        "smile_cat",
        "joy_cat",
        "smiley_cat",
        "heart_eyes_cat",
        "smirk_cat",
        "kissing_cat",
        "pouting_cat",
        "crying_cat_face",
        "scream_cat",
        "slightly_frowning_face",
        "slightly_smiling_face",
        "upside_down_face",
        "face_with_rolling_eyes",
    ];
    const openPicker = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        emojiListDiv.current!.classList.toggle("open");
    };
    const pickEmoji = (e: React.MouseEvent, em: string) => {
        setCurrentEmoji(em);
        fn(em);
        openPicker(e);
    };
    return (
        <div className="emoji__picker">
            <div className="icon-display" onClick={(e) => openPicker(e)}>
                <Emoji el={currentEmoji} />
            </div>
            <div ref={emojiListDiv} className="emoji-grid">
                {emojiList.map((el, index) => {
                    return (
                        <div
                            className="emoji-item"
                            key={index}
                            onClick={(e) => {
                                e.stopPropagation();
                                pickEmoji(e, el);
                            }}
                        >
                            <Emoji el={el} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EmojiPicker;
